import React from "react";
import Button from "@material-ui/core/Button";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import MatUITable from "../../../components/MatUITable/MatUITable";
import Heading from "../../../components/Heading/Heading";
import axios from "../../../utils/Axios/axiosProxy";
import history from "../../../history";
import { orderLabels, proposalsColumns } from "../../../utils/Data/dataTexts";
import { UserDashboardContext } from "../UserDashboard";
import { withTranslation } from "react-i18next";
import i18n from "../../../utils/LanguageSelector/i18n";

function Proposals({ ...props }) {
  const dashboardContext = React.useContext(UserDashboardContext);

  const createTableData = (orders) => {
    let rows = [];
    orders.forEach((order) => {
      let processed = false;
      let unseen = 0;
      order.proposal =
        order.quotation && order.quotesent ? (
          window.innerWidth < 600 ? (
            <CloudDownloadIcon
              style={{ color: "#333a7f" }}
              onClick={() => getPDF(order._id)}
            />
          ) : (
            <Button
              onClick={() => getPDF(order._id)}
              className="TransparentBlue Small"
            >
              {i18n.t("general.download")}
            </Button>
          )
        ) : (
          orderLabels.proposalstatus[order.proposalstatus]
        );
      order.proposalstatuslabel =
        orderLabels.proposalstatus[order.proposalstatus];
      order.messages.forEach((message) => {
        if (message.sender === "admin" && !message.seen) {
          unseen += 1;
        }
        order.unseen = unseen;
      });
      for (let j in order.etr) {
        if (order.etr[j].length > 0 || order.status !== "processing") {
          processed = true;
        }
      }
      if (processed === false) {
        rows.push(order);
      }
    });
    return rows;
  };
  const getPDF = (id) => {
    axios
      .get(`/pdf/quotation_${id}.pdf`, {
        headers: {
          "Content-Type": "application/pdf",
        },
      })
      .then((response) => {
        window.open(response.data.url, "_blank");
        console.log("GET PDF RESPONSE: ", response);
      })
      .catch((error) => {
        console.log("GET PDF ERROR: ", error);
      })
      .catch((error) => console.log("GET PDF CLIENT ERROR", error));
  };
  const updateOrder = (id, proposalstatus, payment) => {
    let data = {
      proposal: true,
      orderID: id,
      updateParams: {
        proposalstatus: proposalstatus,
        payment: payment,
      },
    };
    axios
      .patch("/api/order/update", data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("UPDATE ORDER RESPONSE: ", response.statusText);
        dashboardContext.getUserOrdersMessagesFromDB(
          localStorage.getItem("JWT")
        );
      })
      .catch((error) => {
        console.log("UPDATE ORDER ERROR: ", error.response.data);
      })
      .catch((error) => console.log("submitToDB error", error));
  };

  return (
    <div className="DashboardContent">
      <Heading
        title={i18n.t("dashboardmenu.proposals")}
        titleB={i18n.t("dashboardmenu.neworder")}
        button
        onClick={() => {
          history.push("/form");
        }}
        className="ToreaBay Large"
      />
      <MatUITable
        paging={true}
        pageSize={5}
        updateOrder={updateOrder}
        page="proposal"
        columns={proposalsColumns}
        data={createTableData(props.orders)}
      />
    </div>
  );
}

export default withTranslation()(Proposals);
